import * as React from "react";

const fields = (t) => ({
    config: {columns: 2},
    fields: [
        {
            name: "inventoryStartDate",
            label: t ? t("forms.inventory_start_date") : "Data rozpoczęcia",
            column: 1,
        },
        {
            name: "inventoryStartUsername",
            label: t ? t("forms.inventory_start_user") : "Użytkownik rozpoczął",
            column: 1,
        },
        {
            name: "inventoryEndDate",
            label: t ? t("forms.inventory_end_date") : "Data zakończenia",
            column: 2,
        },
        {
            name: "inventoryEndUsername",
            label: t ? t("forms.inventory_end_user") : "Użytkownik zakończył",
            column: 2,
        },


    ]
    });

export default fields;

